import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_CONFIG } from '../constants/api.constants';
import { SummaryNote, UpsertSummaryNoteRequest } from '../interfaces/summary-notes.interface';

@Injectable({
  providedIn: 'root',
})
export class SummaryNotesService {
  private apiUrl = `${API_CONFIG.BASE_URL}/summary-notes`;

  constructor(private http: HttpClient) {}

  /**
   * Betölti az adott év/hónap összesítő táblázathoz tartozó notesait.
   */
  getNotes(year: number, month: number, isKumMode: boolean): Observable<SummaryNote[]> {
    const params = new HttpParams()
      .set('year', year)
      .set('month', month)
      .set('is_kum_mode', isKumMode);
    return this.http.get<SummaryNote[]>(this.apiUrl, { params });
  }

  /**
   * Létrehoz vagy frissít egy napi note-ot az összesítő táblázathoz.
   */
  upsertNote(req: UpsertSummaryNoteRequest): Observable<SummaryNote> {
    return this.http.post<SummaryNote>(`${this.apiUrl}/upsert`, req);
  }

  /**
   * Töröl egy napi note-ot az összesítő táblázatból.
   */
  deleteNote(year: number, month: number, dayIndex: number, isKumMode: boolean): Observable<void> {
    const params = new HttpParams()
      .set('year', year)
      .set('month', month)
      .set('day_index', dayIndex)
      .set('is_kum_mode', isKumMode);
    return this.http.delete<void>(this.apiUrl, { params });
  }
}
